import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Dbattrs } from '../../../../../core/entities/dbattrs.model';
import { Dbmodels } from '../../../../../core/entities/dbmodels.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsDbattrsComponent } from './dialogs-dbattrs/edit-dialogs-dbattrs/edit-dialogs-dbattrs.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../../../../../core/utils/utils';
import { Router } from '@angular/router';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-dbattrs',
  templateUrl: './dbattrs.component.html',
  styleUrls: ['./dbattrs.component.scss']
})
export class DbattrsComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  dbattr: Dbattrs = new Dbattrs();
  arraydbmodel: Dbmodels[] = new Array<Dbmodels>();

  ruta = '/internal/home/dbmodels';
  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private router: Router) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllDbattrs();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla dbattrs
  */
  private getAllDbattrs(): void {
    console.log(this.internalHomeService.arrayDbmodels);
    this.internalHomeService.chivato = true;
    this.loading = true;
    this.internalHomeService.arrayDbmodels = [];
    this.internalHomeService.allDbattrs().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un dbattr
  * @param dbattr Opcional. Dbattr vacio.
  */
  public createDbattr(dbattr?: Dbattrs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = false;
    dbattr = this.dbattr;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbattrsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbattr, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbattrs();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un dbattr
  * @param dbattr Opcional. Dbattr a editar.
  */
  public editDbattr(dbattr?: Dbattrs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbattrsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbattr, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbattrs();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un dbattr
  * @param dbattr Dbattr a eliminar
  */
  public removeDbattr(dbattr?: Dbattrs) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_dbattrs') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeDbattrs(dbattr).subscribe(res => {
          console.log(res);
          this.getAllDbattrs();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para visualizar el Dbattr.
  * @param dbattr Opcional. Dbattr.
  */
  public viewDbattr(dbattr?: Dbattrs) {
    this.loading = true;
    this.internalHomeService.chivato = false;
    if (dbattr) {
      this.internalHomeService.viewDbattrs = dbattr;
    }
    if(Utils.noUndfAndNull(this.internalHomeService.viewDbattrs)){
      this.router.navigate([this.ruta]);
      this.arraydbmodel = this.internalHomeService.viewDbattrs.dbmodels;
      this.internalHomeService.arrayDbmodels = this.arraydbmodel;
      console.log(this.internalHomeService.arrayDbmodels);
      this.internalHomeService.allDbmodels().subscribe(res => {
        console.log(res);
        this.internalHomeService.chivato = true;
        this.internalHomeService.viewDbattrs.info = false;
        this.loading = false;
      }, error => {
        this.loading = false;
        console.log("Error: " + error);
      });
    }
    this.loading = false;
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
